import * as constants from "../../../constants";

import { GetCommentsParams, GetCommentsResult } from "@/components/comment/actions/types";
import { Comment } from "@/models/comments";

export type CommentState = {
  comment: string;
  list: Comment[]; // nullは未検索, 空はデータなし
  total: number;
  fetching: boolean;
  lastGetCommentsParams?: {
    category_id?: number[];
    comment?: string;
    insert_start_date?: string;
    insert_end_date?: string;
  };
};

const comment = (
  state = {
    comment: "",
    list: null,
    total: 0,
    fetching: false,
  } as CommentState,
  action
) => {
  switch (action.type) {
    case constants.COMMENT_BEGIN_FETCH: {
      const params: GetCommentsParams = action.payload;
      return {
        ...state,
        lastGetCommentsParams: {
          category_id: params.category_id,
          comment: params.comment,
          insert_start_date: params.insert_start_date,
          insert_end_date: params.insert_end_date,
        },
        fetching: true,
      };
    }
    case constants.COMMENT_END_FETCH: {
      const result: GetCommentsResult = action.payload;

      return { ...state, list: result.list, total: result.total_num, fetching: false };
    }
    case constants.APP_SHOW_ERROR: {
      return { ...state, fetching: false };
    }
    case constants.COMMENT_CHANGE_COMMENT: {
      return {
        ...state,
        comment: action.payload,
      };
    }
    default:
      return state;
  }
};

export default comment;
